import { render } from "./openVip.vue?vue&type=template&id=c60a3404"
import script from "./openVip.vue?vue&type=script&lang=js"
export * from "./openVip.vue?vue&type=script&lang=js"

import "./openVip.vue?vue&type=style&index=0&id=c60a3404&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__